<script>
    import _ from 'lodash'
    import * as types from '../store/types'

    export default {
        props: {
            sid: {
                type: String,
                required: false,
                default: () => _.uuid()
            },
            params: {
                type: Object,
                default () {
                    return {}
                }
            },
            include: {
                type: Array,
                default () {
                    return []
                }
            },
            preloaded: {
                type: Object,
                default: null
            },
            getOnCreated: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                is_loading: false,
                has_loaded: false
            }
        },
        computed: {
            error () {
                return this.$store.getters[types.errors.getters.item](this.sid)
            },
            items () {
                return this.$store.getters[types.maintenances.getters.items](this.sid)
            }
        },
        watch: {
            params () {
                this.get()
            }
        },
        created () {
            if (this.preloaded) {
                this.$store.commit(types.maintenances.mutations.got, {
                    sid: this.sid,
                    items: this.preloaded
                })

                this.is_loading = false
                this.has_loaded = true

                this.$emit('success', this.items)
            }

            if (this.getOnCreated) this.get()
        },
        destroyed () {
            this.forget()
        },
        methods: {
            get () {
                this.is_loading = true

                this.promise()
                    .then(() => {
                        this.is_loading = false
                        this.has_loaded = true

                        this.$emit('success', this.items)
                    })
                    .catch(error => {
                        this.is_loading = false

                        this.$error.emit(this, error)
                    })
            },
            promise () {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch(types.errors.actions.forget, { sid: this.sid })

                    return this.$store.dispatch(types.maintenances.actions.get, {
                        sid: this.sid,
                        params: _.extend({ include: this.include.join(',') }, this.params)
                    })
                        .then(() => resolve(this.items))
                        .catch(reject)
                })
            },
            forget () {
                this.$store.dispatch(types.errors.actions.forget, { sid: this.sid })
                this.$store.dispatch(types.maintenances.actions.forget, { sid: this.sid })
            }
        },
        render () {
            return this.$scopedSlots.default({
                sid: this.sid,
                is_loading: this.is_loading,
                has_loaded: this.has_loaded,
                data: _.get(this.items, 'data'),
                meta: _.get(this.items, 'meta'),
                error: this.error,
                find: this.find,
                promise: this.promise,
                forget: this.forget
            })
        }
    }
</script>
